import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Box, Breadcrumbs, CircularProgress, IconButton, Link, Stack, Switch, Tooltip, Typography } from '@mui/material';
import { MdiIcon, useSnackbar, WaitDialog } from '@components';
import { mdiChartBar, mdiChartLine, mdiTable } from '@mdi/js';
import Interacoes from '../../components/interacoes';
import DocumentosAssociados from '../../components/documentosAssociados';
import PessoasAssociadasEmpresa from '../../components/pessoasAssociadasEmpresa';
import CotacoesList from '../../components/cotacoes';
import InfoContactoCliente from '../../components/infoContactoCliente';
import Oportunidades from '../../components/oportunidades';
import OiList from '../../components/oiList';
import ProcessosList from '../../components/processosList';
import Grafico from '../../components/grafico';
import PropostasList from '../../components/propostasList';
import { useModal } from 'mui-modal-provider';
const CrmEmpresasDetailsView = ({ $state, CrmService }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [empresa, setEmpresa] = useState(null);
    const [social, setSocial] = useState(null);
    const [reloadContactos, setReloadContactos] = useState(false);
    // Mostrar Gráficos
    const [showCharts, setShowCharts] = useState(false);
    // Mostrar Tabelas abaixo dos gráficos
    const [showTables, setShowTables] = useState(false);
    // Alterar tipo de gráfico (linhas/barras)
    const [chartType, setChartType] = useState('line');
    //dados propostas emitidas
    const [dadosPE, setDadosPE] = useState([]);
    const [labelsPE, setLabelsPE] = useState([]);
    const [loadPe, setLoadPe] = useState(true);
    //dados propostas em aberto
    const [dadosPA, setDadosPA] = useState([]);
    const [labelsPA, setLabelsPA] = useState([]);
    const [loadPa, setLoadPa] = useState(true);
    //dados volume faturado
    const [dadosVf, setDadosVf] = useState([]);
    const [labelsVf, setLabelsVf] = useState([]);
    const [loadVf, setLoadVf] = useState(true);
    //dados PCA
    const [dadosPCA, setDadosPCA] = useState([]);
    const [labelsPCA, setLabelsPCA] = useState([]);
    const [loadPCA, setLoadPCA] = useState(true);
    const { showModal } = useModal();
    const { showSnackbar } = useSnackbar();
    const fetchData = async () => {
        try {
            const getEmpresa = await CrmService.findEmpresaById($state.params.id);
            //console.log(getEmpresa);
            if (getEmpresa?.redesSociais) {
                const parsedSocial = JSON.parse(getEmpresa.redesSociais);
                setSocial(parsedSocial);
            }
            else {
                setSocial([]);
            }
            setEmpresa(getEmpresa);
        }
        catch (e) {
            console.log(e);
        }
        setIsLoading(false);
    };
    // Pedidos de cotação em aberto (estados -> em cotação, em edição dep. externo, concluído)
    const getPCA = async () => {
        try {
            let pca = await CrmService.getPCA(empresa.id);
            const x = groupAndSortPCA(pca);
            setDadosPCA(x.valuesArray);
            setLabelsPCA(x.monthsArray);
            setLoadPCA(false);
        }
        catch (error) {
            console.log('Erro ao obter propostas emitidas', error);
        }
    };
    const getVolumeFaturado = async () => {
        try {
            let vf = await CrmService.getVolumeFaturado(empresa.refClientePrimavera);
            const x = groupAndSortPropostas(vf);
            setDadosVf(x.valuesArray);
            setLabelsVf(x.monthsArray);
            setLoadVf(false);
        }
        catch (error) {
            console.log('Erro ao obter propostas emitidas', error);
        }
    };
    const getPropostasEmAberto = async () => {
        try {
            let pa = await CrmService.getPropostasEmAberto(empresa.refClientePrimavera);
            const x = groupAndSortPropostas(pa);
            setDadosPA(x.valuesArray);
            setLabelsPA(x.monthsArray);
            setLoadPa(false);
        }
        catch (error) {
            console.log('Erro ao obter propostas emitidas', error);
        }
    };
    const getPropostasEmitidas = async () => {
        try {
            let pe = await CrmService.getPropostasEmitidas(empresa.refClientePrimavera);
            const x = groupAndSortPropostas(pe);
            setDadosPE(x.valuesArray);
            setLabelsPE(x.monthsArray);
            setLoadPe(false);
        }
        catch (error) {
            console.log('Erro ao obter propostas emitidas', error);
        }
    };
    // Ordenar os dados (e datas) extraír os últimos 12 meses
    const groupAndSortPropostas = (propostas) => {
        const today = new Date();
        const lastYear = new Date(today);
        lastYear.setFullYear(today.getFullYear() - 1);
        const grouped = propostas.reduce((acc, proposta) => {
            const date = new Date(proposta.data);
            const month = proposta.data.substring(0, 7); // Extrai "YYYY-MM"
            // Considera apenas os últimos 12 meses
            if (date >= lastYear && date <= today) {
                if (!acc[month]) {
                    acc[month] = 0;
                }
                acc[month] += proposta.totalmerc;
            }
            return acc;
        }, {});
        // Garante que todos os últimos 12 meses estejam no objeto, mesmo sem valores
        const monthsArray = [];
        const valuesArray = [];
        for (let i = 11; i >= 0; i--) {
            const date = new Date(today);
            date.setMonth(today.getMonth() - i);
            const monthStr = date.toISOString().substring(0, 7);
            monthsArray.push(monthStr);
            valuesArray.push(grouped[monthStr] || 0);
        }
        return { monthsArray, valuesArray };
    };
    const groupAndSortPCA = (pcaList) => {
        const today = new Date();
        const lastYear = new Date(today);
        lastYear.setFullYear(today.getFullYear() - 1);
        // Agrupa os dados por mês
        const grouped = pcaList.reduce((acc, pca) => {
            const date = new Date(pca.dataAbertura);
            const month = pca.dataAbertura.substring(0, 7); // Extrai "YYYY-MM"
            // Considera apenas os últimos 12 meses
            if (date >= lastYear && date <= today) {
                acc[month] = (acc[month] || 0) + 1;
            }
            return acc;
        }, {});
        // Garante que todos os últimos 12 meses estejam no objeto, mesmo sem valores
        const monthsArray = [];
        const valuesArray = [];
        for (let i = 11; i >= 0; i--) {
            const date = new Date(today);
            date.setMonth(today.getMonth() - i);
            const monthStr = date.toISOString().substring(0, 7);
            monthsArray.push(monthStr);
            valuesArray.push(grouped[monthStr] || 0);
        }
        return { monthsArray, valuesArray };
    };
    const handleShowCharts = () => {
        setShowCharts(!showCharts);
    };
    const syncWithPrimavera = async () => {
        const wait = showModal(WaitDialog, { title: 'Por favor aguarde...' });
        try {
            await CrmService.reSyncClient(empresa.refClientePrimavera);
            fetchData();
            wait.destroy();
            showSnackbar('Sincronização com o Primavera efetuada');
        }
        catch (e) {
            showSnackbar('Ocorreu erro ao sincronizar com o Primavera');
        }
    };
    useEffect(() => {
        if (empresa == null) {
            fetchData();
        }
        else {
            getPropostasEmitidas();
            getPropostasEmAberto();
            getVolumeFaturado();
            getPCA();
        }
    }, [empresa]);
    return (<Box sx={{ mt: 2, pl: 1, pr: 1 }}>
      {empresa ? (<Box>
          <Breadcrumbs aria-label='breadcrumb'>
            <Link underline='none' color='inherit'>
              CRM
            </Link>
            <Link underline='hover' color='text.primary' href={$state.href('app.crm.empresas.list')}>
              Clientes
            </Link>
        
          </Breadcrumbs>

          {isLoading ? (<Box sx={{ display: 'flex', justifyContent: 'center', height: '2vh' }}>
              <CircularProgress size={60} color='primary'/>
            </Box>) : (<Grid container spacing={2} justifyContent='flex-start' alignItems='center'>
              <Grid item xs={12}>
                <InfoContactoCliente $state={$state} empresa={empresa} edit={true} handleShowChart={handleShowCharts} chartState={showCharts} syncData={syncWithPrimavera}></InfoContactoCliente>
              </Grid>

              {showCharts ? (<>
                  <Grid item xs={12}>
                    <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={2}>
                      <Typography variant='h6' sx={{ color: 'black' }}>
                        Indicadores
                      </Typography>

                      <Stack direction='row'>
                        <Tooltip title={chartType === 'line' ? 'Alterar par gráfico de Barras' : 'Alterar par gráfico de Linhas'} placement='top'>
                          <IconButton onClick={() => {
                        chartType === 'line' ? setChartType('bar') : setChartType('line');
                    }}>
                            <MdiIcon path={chartType === 'line' ? mdiChartLine : mdiChartBar} sx={{ color: '#0288d1' }}></MdiIcon>
                          </IconButton>
                        </Tooltip>

                        <Tooltip title={!showTables ? 'Mostrar tabelas' : 'Esconder tabelas'}>
                          <Switch onChange={() => setShowTables(!showTables)}/>
                        </Tooltip>
                        <MdiIcon path={mdiTable} sx={{ color: showTables ? '#0288d1' : 'default' }}></MdiIcon>
                      </Stack>
                    </Stack>
                    <Box>
                      <Grid item xs={12}>
                        <Grid container spacing={2} alignItems='center'>
                          {loadPe ? (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography variant='subtitle1'> A carregar dados de propostas emitidas</Typography>
                              <CircularProgress size={30}/>
                            </Grid>) : (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Grafico title='Valor Propostas Emitidas €' bgColor='rgba(75, 192, 75, 0.2)' borderColor='rgba(75, 192, 75, 1)' type={chartType} showTable={showTables} labels={labelsPE} values={dadosPE}/>
                            </Grid>)}

                          {loadPa ? (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography variant='subtitle1'> A carregar dados de propostas em aberto</Typography>
                              <CircularProgress size={30}/>
                            </Grid>) : (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Grafico title='Valor Propostas em Aberto €' bgColor='rgba(250, 20, 20, 0.2)' borderColor='rgba(250, 20, 20, 1)' type={chartType} showTable={showTables} labels={labelsPA} values={dadosPA}/>
                            </Grid>)}

                          {loadVf ? (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography variant='subtitle1'> A carregar dados de Volume faturado</Typography>
                              <CircularProgress size={30}/>
                            </Grid>) : (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Grafico title='Volume Faturado €' bgColor='rgba(20, 60, 245, 0.2)' borderColor='rgba(20, 60, 245, 1)' type={chartType} showTable={showTables} labels={labelsVf} values={dadosVf}/>
                            </Grid>)}

                          {loadPCA ? (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Typography variant='subtitle1'> A carregar dados de PCA</Typography>
                              <CircularProgress size={30}/>
                            </Grid>) : (<Grid item xs={12} sm={12} md={6} lg={6}>
                              <Grafico title='PCA - Pedidos de Cotação em Aberto €' bgColor='rgba(150, 0, 255, 0.2)' borderColor='rgba(150, 0, 255, 1)' type={chartType} showTable={showTables} labels={labelsPCA} values={dadosPCA}/>
                            </Grid>)}

                          <Grid item xs={false} sm={false} md={2}></Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </>) : (<></>)}

              <Grid item xs={12}>
                <Stack direction='column' spacing={4}>
                  <PessoasAssociadasEmpresa $state={$state} CrmService={CrmService} client={empresa.id} load={reloadContactos}/>

                  <Interacoes $state={$state} CrmService={CrmService} client={empresa.id}/>

                  <CotacoesList $state={$state} CrmService={CrmService} bloqueado={empresa.bloqueadoPrimavera == 1} client={empresa.id}/>

                  <PropostasList $state={$state} CrmService={CrmService} client={empresa.id}/>

                  <OiList $state={$state} CrmService={CrmService} client={empresa.id}/>

                  <ProcessosList $state={$state} CrmService={CrmService} client={empresa.id}/>

                  <Oportunidades $state={$state} CrmService={CrmService} client={empresa.id}/>

                  <DocumentosAssociados $state={$state} CrmService={CrmService} client={empresa.id} readOnly={false}/>
                </Stack>
              </Grid>
            </Grid>)}
        </Box>) : (<Stack direction='row' justifyContent='center' alignItems='flex-start' sx={{ mt: 4 }}>
          <CircularProgress size={50}/>
        </Stack>)}
    </Box>);
};
export default CrmEmpresasDetailsView;
